import { css } from '@emotion/react'
import { curry } from 'utils/fp'

export const theme = {
  colors: {},
}

export const color = curry((colorName, props) => props.theme.colors[colorName])

export const globalStyles = css`
  body {
    margin: 0;
    padding: 0;
  }

  a {
    color: sandybrown;
    font-weight: bold;
    text-decoration: none;
  }
`
